<p-toast></p-toast>
<div>
    <p-steps [model]="stepItems" [activeIndex]="activeIndex"></p-steps>
</div>
<div>
    <h3>
        Student information
    </h3>
    <div>
        <p>
            Last name:
        </p>
        <p>
            {{bookingService.booking.student.lastName}}
        </p>
    </div>
</div>
<div>
    <p>Uploaded by client</p>
    <p-table [value]="uploadedClientFiles">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    ID
                </th>
                <th>
                    filename
                </th>
                <th [style]="{'width': '200px'}">
                    filetype
                </th>
                <th>
                    need signature
                </th>
                <th>
                    uploaded
                </th>
                <th>
                    download
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file let-rowIndex="rowIndex">
            <tr [formGroup]="fileForms[rowIndex]">
                <td>
                    {{file.id}}
                </td>
                <td>
                    {{file.fileName}}
                </td>
                <td>
                    <p-dropdown placeholder="-----" [options]="fileTypes" formControlName="fileType" optionLabel="name"
                        [style]="{'min-width': '180px', 'width': '180px'}" (onChange)="updateFile(rowIndex, file)">
                    </p-dropdown>
                </td>
                <td>
                    <p-checkbox formControlName="needsSignature" [binary]="true" (onChange)="updateFile(rowIndex, file)">
                    </p-checkbox>
                </td>
                <td>
                    {{file.created | date:'dd/MM/yyyy'}}
                </td>
                <td>
                    <p-button icon="pi pi-download" (onClick)="downloadFile(file.id, file.fileName)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div>
    Messages:
    <div class="chat-messages-container">
        <div *ngFor="let chat of bookingChats"
            [ngClass]="{'chat-message-right': chat.createdBy, 'chat-message-left': !chat.createdBy}">
            <div [innerHtml]="chat.message | safeHtml" class="chat-text-container"></div>
            {{chat.created}}
            <p *ngIf="chat.createdBy">
                {{chat.createdBy.name}}
            </p>
            <p *ngIf="!chat.createdBy">
                {{chat.studentName}}
            </p>
        </div>
        <div class="chat-input-container">
            <textarea [(ngModel)]="selectedChatMessage" class="new-chat-input"></textarea>
            <p-button label="Submit" (onClick)="postChatMessage()"></p-button>
        </div>
    </div>
</div>